
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/categories/[category]",
      function () {
        return require("private-next-pages/blog/categories/[category]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/categories/[category]"])
      });
    }
  